import Vue from "vue";
import Organization from "~/models/organization";
import Visualization from "~/models/visualizations/visualization";
import VisualizationDataTableFilter from "~/models/visualizations/visualizationDataTableFilter";
import Selected from "../store/modules/selected";
import User from "~/models/user";

export default Vue.extend({
  computed: {
    selectedVisualization(): Visualization {
      return Selected.visualization.get();
    },
    selectedSourceDataPoint(): any {
      return Selected.selectedDataPoint.get();
    },
    selectedDragDataPoint(): any {
      return Selected.selectedDragDataPoint.get();
    },
    selectedFilter(): VisualizationDataTableFilter {
      return Selected.selectedDataTableFilter.get();
    },
    selectedOrganization(): Organization {
      return Selected.organization.get();
    },
    currentUser(): User {
      return Selected.currentUser.get();
    },
  },
});